import controller from './oauth.controller';
import template from './oauth.pug';

const OauthComponent = {
  template,
  controller,
};

export default OauthComponent;



// WEBPACK FOOTER //
// ./client/app/oauth/oauth.component.js